// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"6041c4e1","48":"9dcaeae6","109":"621f56d3","381":"26db8a80","473":"024ae9a4","543":"47881a83","594":"446d91ee","604":"2465aa05","775":"26865193","806":"a7496c42"}[chunkId] + ".chunk.js";
};